import { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import ReactLoading from "react-loading";
import useFetchWithAuthorization from "../Apis/useFetchWithAuthorization";

const Addproduct = () => {
  const navigate = useNavigate();
  const [cookies] = useCookies(["token"]);
  const token = cookies.token;
  const [isLoading, setIsLoading] = useState(false); // New state variable
  const [isPriceValid, setIsPriceValid] = useState(true);
  const [isfileLarge, setUsFileLarge]= useState(false)
  const [errors, setError] = useState(false);
  const [resetFileInput, setResetFileInput] = useState(false); // New state variable
  const [sendNotification, setsendNotification] = useState(false); // New state variable

  const { data, loading, error } = useFetchWithAuthorization(
    "https://campus-closet-server.vercel.app/profile"
  );

  const [formData, setFormData] = useState({
    productCategory: "",
    productName: "",
    productDescription: "",
    productPhoto: null,
    price: "",
    PhoneNumber: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handlePhotoUpload = (e) => {
    const file = e.target.files[0];
    setFormData((prevFormData) => ({
      ...prevFormData,
      productPhoto: file,
    }));
  };

  //checking if the phone number is valid
  const transformPhoneNumber = (inputNumber) => {
    // Remove any non-digit characters (e.g., spaces, dashes)
    const cleanNumber = inputNumber.replace(/\D/g, "");

    if (cleanNumber.startsWith("0") && cleanNumber.length === 10) {
      // If the number starts with "0" and has 10 digits
      return `254${cleanNumber.slice(1)}`;
    } else if (cleanNumber.startsWith("+254") && cleanNumber.length !== 13) {
      // If the number starts with "+254" and has more than 13 digits or less than 13 digits, it is invalid
      return null;
    } else if (cleanNumber.startsWith("0") && cleanNumber.length !== 10) {
      // If the number starts with "0",it should have 10 digits
      return null;
    } else {
      // Otherwise, return null to indicate an invalid number
      return null;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log(formData);
    // Validate the price input
    const isValidPrice = /^\d+$/.test(formData.price);
    setIsPriceValid(isValidPrice); // Update the state based on the validation result
    setTimeout(() => {
      setIsPriceValid(true);
    }, 3000);
    if (!isValidPrice) {
      return;
    }
    let transformedPhoneNumber = null;

    // Check if the phone number is not null
    if (formData.PhoneNumber) {
      transformedPhoneNumber = transformPhoneNumber(formData.PhoneNumber);

      // Check if the phone number is valid
      if (transformedPhoneNumber === null) {
        // There is an error in the phone number
        console.log("Enter a valid number");
        setError("Enter a valid number");
        setTimeout(() => {
          setError("");
        }, 3000);
        return;
      }
    }

    //comress file b4 upload
    const fileInput = document.getElementById("productPhoto"); // Assuming your file input has the id "fileInput"

    if (fileInput.files.length > 0) {
      const fileSize = fileInput.files[0].size; // Get the file size in bytes
      const maxSizeInBytes = 3 * 1024 * 1024; // 3MB in bytes
  
      if (fileSize > maxSizeInBytes) {
        setUsFileLarge(true)
        setTimeout(() => {
          setUsFileLarge(false)
        }, 20000);
        return;
      }
    }
    setIsLoading(true); // Set isLoading to true when the submission starts

    const formDataToSend = new FormData();
    formDataToSend.append("productCategory", formData.productCategory);
    formDataToSend.append("productName", formData.productName);
    formDataToSend.append("productDescription", formData.productDescription);
    formDataToSend.append("productPhoto", formData.productPhoto);
    formDataToSend.append("price", formData.price);
    formDataToSend.append("PhoneNumber", transformedPhoneNumber);
    console.log("formData:", formData); // Log the formData
    fetch("https://campus-closet-server.vercel.app/products", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formDataToSend,
    })
      .then((res) => {
        console.log(res);
        setIsLoading(false); // Set isLoading back to false after the submission is completed
        if (res.ok) {
          console.log("Product added successfully");
          toast.success("Product added successfully!", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
          setFormData({
            productCategory: "",
            productName: "",
            productDescription: "",
            productPhoto: null,
            price: "",
            PhoneNumber: "",
          });
          setResetFileInput(true); // Set the resetFileInput state to true to reset the file input field
          setsendNotification(true);
          setTimeout(() => {
            // navigate('/Admin');
          }, 5000);
          return res.json();
        } else {
          console.log("i want to log the details about the err here");
          throw new Error("Error adding the product");
        }
      })
      .then((data) => {
        // Handle the response data
        console.log(data);
      })
      .catch((error) => {
        console.error("API request error:", error);
        setIsLoading(false);
        toast.error("Error adding the product. Please try again later.", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });
      });
  };

  // Reset the file input field when resetFileInput state changes to true
  useEffect(() => {
    if (resetFileInput) {
      setResetFileInput(false);
      document.getElementById("productPhoto").value = ""; // Reset the value of the file input field
    }
  }, [resetFileInput]);

  if (!token) {
    return (
      <div
        style={{ height: `calc(100vh - 100px)` }}
        className=" flex justify-center"
      >
        <div>
          <h1>Unauthorized Access</h1>
          <button
            onClick={() => navigate("/login")}
            className={`w-full text-gray-900 bg-blue-400 hover:bg-blue-500 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center`}
          >
            Login
          </button>
        </div>
      </div>
    ); // Return null or any other suitable component while redirecting
  }
  return (
    <section>
      {isLoading && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-900 opacity-60">
          <div>
            <ReactLoading
              type="spinningBubbles"
              color="#ffffff"
              height={80}
              width={80}
            />
            <p className="text-white">This may take a little while!</p>
          </div>
        </div>
      )}
      {loading && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-900 opacity-90">
          <div>
            <ReactLoading
              type="spinningBubbles"
              color="#ffffff"
              height={80}
              width={80}
            />
            <p className="text-white">Loading...</p>
          </div>
        </div>
      )}
      {/* property of Admin panel */}
      {/* <div className="bg-slate-100 flex py-3">
          <h1 className="text-2xl mx-auto font-bold mb-4">Admin_Panel</h1>
        </div> */}
      <div className="my-4 flex flex-col items-center justify-center px-6 py-8 mx-auto lg:py-0">
        <div className="form w-full bg-white rounded-lg shadow dark:border md:mt-0  sm:max-w-md xl:p-0 ">
          <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
            <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl">
              Add Your Product Here
            </h1>
            <form className="space-y-4 md:space-y-6 " onSubmit={handleSubmit}>
              <div>
                <label
                  htmlFor="productCategory"
                  className="block mb-2 text-sm font-medium text-gray-900"
                >
                  Product Category
                </label>
                <select
                  name="productCategory"
                  id="productCategory"
                  className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5"
                  required
                  value={formData.productCategory}
                  onChange={handleChange}
                >
                  <option value="">Select Category</option>
                  <option value="HouseHolds">HouseHolds</option>
                  <option value="Electronics">Electronics</option>
                  <option value="Funitures">Funitures</option>
                  <option value="Others">Others</option>
                </select>
              </div>

              <div>
                <label
                  htmlFor="email"
                  className="block mb-2 text-sm font-medium text-gray-900"
                >
                  Product Name
                </label>
                <input
                  type="text"
                  name="productName"
                  id="productName"
                  className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5"
                  placeholder="Name of your Product"
                  required
                  value={formData.productName}
                  onChange={handleChange}
                />
              </div>
              <div>
                <label
                  htmlFor="email"
                  className="block mb-2 text-sm font-medium text-gray-900"
                >
                  Product Descriptions
                </label>
                <input
                  type="text"
                  name="productDescription"
                  id="productDescription"
                  className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5"
                  placeholder="Tell Us more about your product with less than 70 words"
                  required
                  value={formData.productDescription}
                  onChange={handleChange}
                  onInput={(e) => {
                    const input = e.target.value;
                    const words = input.split(" ");
                    if (words.length > 70) {
                      e.target.value = words.slice(0, 70).join(" ");
                    }
                  }}
                />
              </div>
              <div>
                <label
                  htmlFor="photo"
                  className="block mb-2 text-sm font-medium text-gray-900"
                >
                  Product Photo
                </label>
                <input
                  type="file"
                  name="productPhoto"
                  id="productPhoto"
                  className={`bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5
                  ${!isfileLarge ? "" : "border-red-500"}`}
                  required
                  onChange={handlePhotoUpload}
                />
              </div>
              {isfileLarge && (
                  <p className="text-red-500">
                    File size is too large. Please compress the file and try again. 
                    <a className="text-blue-700 underline" href="https://www.iloveimg.com/compress-image" target="_blank" rel="noopener noreferrer">Click here</a> to Compress
                  </p>
                )}
              <div>
                <label
                  htmlFor="password"
                  className="block mb-2 text-sm font-medium text-gray-900"
                >
                  Price
                </label>
                <input
                  type="text"
                  name="price"
                  id="price"
                  placeholder="eg ksh. 1000"
                  className={`bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 ${
                    isPriceValid ? "" : "border-red-500"
                  }`}
                  required
                  value={formData.price}
                  onChange={handleChange}
                />
                {!isPriceValid && (
                  <p className="text-red-500">
                    Price should contain numbers only.
                  </p>
                )}
              </div>
              {data && (
                <div>
                  {!data.user.Phone_Number && (
                    <div>
                      <label
                        htmlFor="phone"
                        className="block mb-2 text-sm font-medium text-gray-900"
                      >
                        Your Phone Number
                      </label>
                      <input
                        type="text"
                        name="PhoneNumber"
                        id="PhoneNumber"
                        placeholder=""
                        className={`bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 `}
                        required
                        value={formData.PhoneNumber}
                        onChange={handleChange}
                      />
                      {errors && (
                        <p className="text-red-500">Enter a valid number</p>
                      )}
                    </div>
                  )}
                </div>
              )}
              <button
                type="submit"
                className={`w-full text-gray-900 opacity-100 bg-blue-400 hover:bg-blue-500 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center${
                  isLoading ? "opacity-50 cursor-not-allowed" : ""
                }`}
                // disabled={isLoading}// Disable the button when isLoading is true
              >
                {isLoading ? "Loading... please wait" : "Upload"}{" "}
                {/* Display "Loading..." when isLoading is true */}
              </button>
              {sendNotification && (
                <p className="text-green-600">
                  We will send you a Notification via Email once your item has
                  been ordered. Please keep on checking your Email
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
      <ToastContainer />
    </section>
  );
};

export default Addproduct;
